import React from 'react';
import './FullPageSpinner.css';
import Spinner from './Spinner';

function FullPageSpinner() {
  return (
    <div className='FullPageSpinner'>
      <Spinner />
    </div>
  );
}

export default FullPageSpinner;